import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareVersionDetailRoute: InvariantJiraRoute = {
	name: 'software-version-detail',
	path: '/projects/:projectKey/versions/:versionId/tab/:tab',
};
